import { postMethodWithTokenWIthFormData } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const FILE_UPLOAD = 'FILE_UPLOAD';
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_FAILURE = 'FILE_UPLOAD_FAILURE';

// Action Creators
export const fileUpload = () => ({
  type: FILE_UPLOAD,
});

export const fileUploadSuccess = (data) => ({
  type: FILE_UPLOAD_SUCCESS,
  payload: data,
});

export const fileUploadFailure = (error) => ({
  type: FILE_UPLOAD_FAILURE,
  payload: error,
});

// Thunk Function
export const fileUploadCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fileUpload(data, external));
    try {
      const response = await postMethodWithTokenWIthFormData(
        url.fileUpload,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fileUploadSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fileUploadFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fileUploadFailure(error.message));
    }
  };
};
